import { render, staticRenderFns } from "./UserModal.vue?vue&type=template&id=f12edac4&scoped=true"
import script from "./UserModal.vue?vue&type=script&lang=js"
export * from "./UserModal.vue?vue&type=script&lang=js"
import style0 from "./UserModal.vue?vue&type=style&index=0&id=f12edac4&prod&scoped=true&lang=css"
import style1 from "./UserModal.vue?vue&type=style&index=1&id=f12edac4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f12edac4",
  null
  
)

export default component.exports